import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const COOKIE_CONSENT_KEY = "idk-cookie-consent";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
            <div className="max-w-4xl mx-auto p-6 md:p-8 relative rounded-3xl bg-card border border-border shadow-2xl"
                 style={{ backdropFilter: 'blur(40px)' }}
            >
            <button
              onClick={handleDecline}
              className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="flex-1 pr-8 md:pr-0">
                <h3 className="text-lg font-bold text-foreground mb-2">
                  🍪 Cookies
                </h3>
                <p className="text-sm text-muted-foreground">
                  {t('cookie.message')}{" "}
                  <Link 
                    to="/cookies" 
                    className="text-lime hover:underline"
                  >
                    {t('cookie.policy')}
                  </Link>
                  .
                </p>
              </div>

              <div className="flex items-center gap-3 w-full md:w-auto">
                <button
                  onClick={handleDecline}
                  className="flex-1 md:flex-none px-6 py-2.5 text-sm font-medium text-muted-foreground 
                             hover:text-foreground border border-border rounded-full 
                             transition-colors hover:bg-muted"
                >
                  {t('cookie.decline')}
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 md:flex-none px-6 py-2.5 text-sm font-medium bg-lime 
                             text-background rounded-full transition-all hover:shadow-glow 
                             hover:scale-105"
                >
                  {t('cookie.accept')}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
